export enum RequestState {
    Idle = 0,
    Pending = 1,
    Success = 2,
    Failure = 3
}